import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Drawer, Typography, Chip, Grid } from '@material-ui/core'
import Risk from '../../CheckBoxContainer/Risks'
import { t as i18n } from 'ttag'

const useStyles = makeStyles({
  root: {
    margin: 4
  },
  list: {
    width: 250
  },
  fullList: {
    width: 'auto',
    margin: 24
  }
})

const RisksChip = () => {
  const classes = useStyles()
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false
  })

  const toggleDrawer = (side, open) => event => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }

    setState({ ...state, [side]: open })
  }

  const riskList = side => (
    <div
      className={classes.fullList}
      role='presentation'
      onClick={toggleDrawer(side, true)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <Typography variant='h6' gutterBottom>
        {i18n`Risks`}
      </Typography>
      <Risk />
    </div>
  )

  return (
    <div>
      <Grid className={classes.root}>
        <Chip
          variant='outlined'
          label={i18n`Risks`}
          color='primary'
          onClick={toggleDrawer('top', true)}
        />
      </Grid>
      <Drawer
        anchor='top'
        open={state.top}
        onClose={toggleDrawer('top', false)}
      >
        {riskList('top')}
      </Drawer>
    </div>
  )
}

export default RisksChip
